import amplitude from 'amplitude-js';

const KEY = process.env.REACT_APP_AMPLITUDE_KEY || 'd78a64ce4ecb8243d7b58557b588308d';
const COOKIE_DOMAIN = process.env.REACT_APP_AMPLITUDE_COOKIE_DOMAIN || '.joonhealth.co';

let initialized = false;

export function initAmplitude() {
  if (initialized || typeof window === 'undefined') return;
  amplitude.getInstance().init(KEY, null, {
    domain: COOKIE_DOMAIN,
    includeUtm: true,
    includeReferrer: true,
    includeGclid: true,
  });
  initialized = true;
}

export function track(event, props = {}) {
  if (typeof window === 'undefined') return;
  if (!initialized) initAmplitude();
  try {
    amplitude.getInstance().logEvent(event, props);
  } catch (e) {
    // analytics is best-effort; never break the app
    console.warn('amplitude track failed', e);
  }
}

export function getDeviceId() {
  if (typeof window === 'undefined') return null;
  if (!initialized) initAmplitude();
  return amplitude.getInstance().options.deviceId || null;
}
